import React from 'react';

import { Link } from '@ergeon/core-components';
import { VideoCameraIcon } from '@ergeon/icons/hero/micro';

interface LveMessageProps {
  durationStr?: string | null;
  recordingUrls?: string[] | null;
}

const getRecordingLabel = (url: string, index: number): string => {
  if (url.endsWith('.mp3')) {
    return 'Audio';
  }
  if (url.endsWith('.mp4')) {
    return 'Video';
  }
  return `Recording ${index + 1}`;
};

export const LveMessage: React.FC<LveMessageProps> = ({ durationStr, recordingUrls }) => (
  <div className="flex gap-2">
    <div className="flex items-center gap-1">
      <VideoCameraIcon className="size-4" />
      LVE - {durationStr || 'Unknown duration'}
    </div>
    {recordingUrls && recordingUrls.length > 0 && (
      <div className="flex gap-2">
        {recordingUrls.map((url, index) => (
          <Link href={url} key={url} target="_blank">
            {getRecordingLabel(url, index)}
          </Link>
        ))}
      </div>
    )}
  </div>
);
